import * as React from "react";

const ConfirmDialog = ({
  title,
  message,
  confirmText,
  color,
  onConfirm,
  onCancel,
  icon,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg w-11/12 max-w-md p-6">
        <div className="flex justify-between gap-2">
          <h2 className="text-lg font-semibold mb-4 text-gray-800 dark:text-gray-100">
            {title}
          </h2>
          {icon && (
            <div
              className={`w-12 h-12 ${color === "red" ? "text-red-500" : "text-blue-500"}`}
            >
              {React.createElement(icon)}
            </div>
          )}
        </div>

        <p className="mb-6 text-gray-600 dark:text-gray-300">{message}</p>

        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-300 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded hover:bg-gray-400 transition"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-2 text-white rounded hover:opacity-90 transition ${
              color === "red"
                ? "bg-red-500 hover:bg-red-600"
                : "bg-blue-500 hover:bg-blue-600"
            }`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
